import { NgModule } from '@angular/core';
import { NoDataMessageComponent } from './no-data-message.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [NoDataMessageComponent],
  imports: [TranslateModule],
  exports: [NoDataMessageComponent],
})
export class NoDataMessageModule {}
